import React from "react";

function Line() {
  return <div className="default-ltr-cache-1f97ztc"></div>;
}

export default Line;
